// extracted by mini-css-extract-plugin
export default {"noteBox":"note_noteBox__8K91b","topBox":"note_topBox__xjd-k","tags":"note_tags__-OavX"};